import React from 'react'
import { createRoot } from 'react-dom/client'
import { HomepageNav } from '../components/HomepageNav'
import { MotionProvider } from '../lib/motionProvider'

const mountHomepageNav = () => {
  const rootEl = document.getElementById('homepage-nav-root')
  if (!rootEl) return

  if (rootEl.dataset.mounted === 'true') return
  rootEl.dataset.mounted = 'true'

  const props = JSON.parse(rootEl.dataset.props || '{}')

  const root = createRoot(rootEl)
  root.render(
    <MotionProvider>
      <HomepageNav {...props} />
    </MotionProvider>,
  )
}

document.addEventListener('turbo:load', mountHomepageNav)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountHomepageNav)
} else {
  mountHomepageNav()
}
